import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import IndecIndex from "@/views/index/IndexIndex.vue";
import OverviewIndex from "@/views/overview/OverviewIndex.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "indecIndex",
    component: IndecIndex,
    meta: {
      keepAlive: false, //设置页面是否需要使用缓存
    },
    children: [
      {
        path: "overviewIndex",
        name: "overviewIndex",
        component: OverviewIndex,
      },
      {
        path: "about",
        name: "about",
        component: () => import("@/views/AboutView.vue"),
        children: [
          {
            name: "homeView",
            path: "homeView",
            component: HomeView,
          },
          {
            name: "indexPage",
            path: "indexPage",
            component: () => import("@/views/homePage/homePageIndex.vue"),
          },
        ],
      },
      {
        path: "main",
        name: "main",
        meta: {
          keepAlive: false, //设置页面是否需要使用缓存
        },
        component: () => import("@/views/main/MainIndex.vue"),
      },
      {
        path: "checklistIndex",
        name: "ChecklistIndex",
        meta: {
          keepAlive: false, //设置页面是否需要使用缓存
        },
        component: () => import("@/views/checklist/ChecklistIndex.vue"),
      },
      {
        path: "portmain/:id",
        name: "portmain",
        meta: {
          keepAlive: false, //设置页面是否需要使用缓存
        },
        component: () => import("@/views/port/main/MainIndex.vue"),
      },
      {
        path: "portintroduce",
        name: "portintroduce",
        meta: {
          keepAlive: false, //设置页面是否需要使用缓存
        },
        component: () => import("@/views/port/introduce/IntroduceIndex.vue"),
      },
      {
        path: "",
        name: "search",
        meta: {
          keepAlive: false, //设置页面是否需要使用缓存
        },
        component: () => import("@/views/port/search/SearchIndex.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 在全局 beforeEach 守卫中检查 noCache 标记
router.beforeEach((to, from, next) => {
  if (to.meta.noCache) {
    to.matched.forEach((record) => {
      record.instances.default = null; // 强制重新创建组件实例
    });
  }
  next();
});

export default router;
